<template>
  <div class="home">
    <div class="carousel-wrapper">
      <el-carousel height="670px">
        <el-carousel-item v-for="item in carousel" :key="item.url">
          <el-image :src="item.url" alt="" class="carousel-img"></el-image>
        </el-carousel-item>
      </el-carousel>

      <div class="carousel-overlay">
        <div class="overlay-content">
          <div class="main-title">AI科研赋能</div>
          <div class="sub-title">
            双源接入DeepSeek与PubMed
          </div>
          <div class="line-group">
            <div v-for="item in 3" :key="item" class="white-line"></div>
          </div>
        </div>
        <div class="carousel-bottom-cards">
          <div v-for="item in carouselItems" :key="item.title" class="feature-card">
            <el-image :src="item.icon" class="feature-icon"></el-image>
            <div>
              <div class="feature-title">{{ item.title }}</div>
              <div class="feature-desc">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="product-section">

      <div class="section-title">产品</div>

      <div class="product-content">
        <div class="product-left">
          <div class="product-sub-title">应用平台</div>
          <ul class="product-list">
            <li><span class="dot"></span><span>为中小型研发机构提供完整的实验室管理解决方案</span></li>
            <li><span class="dot"></span> <span>引领管理升级和支撑业务发展</span></li>
            <li><span class="dot"></span> <span>提高实验的速度，质量，公平性</span></li>
            <li><span class="dot"></span> <span>一个平台/多个应用/按需组合</span></li>
          </ul>

          <el-image class="decor-img1"
            src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/o2-092103514.png"></el-image>
        </div>
        <div class="product-right">
          <el-image class="product-main-img"
            src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/o1-091235692.png"></el-image>

          <el-image class="decor-img2"
            src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/o3-092333649.png"></el-image>
        </div>
      </div>

    </div>

    <div class="solution-section">
      <div class="section-title">解决方案</div>

      <div class="solution-content">
        <div v-for="item in scheme" :key="item.title" class="solution-card">
          <div>
            <div class="solution-title">{{ item.title }}</div>
            <div class="solution-desc">{{ item.description }}</div>
          </div>
          <div>
            <el-image class="solution-icon" :src="item.icon"></el-image>
          </div>
        </div>
      </div>
    </div>

    <div class="orientation-section">
      <div class="section-title">核心定位</div>
      <div class="orientation-sub-title">一站式科研实验室数字化解决方案，提高实验的速度、质量、公平性</div>

      <div class="orientation-img-wrapper">
        <el-image class="orientation-main-img"
          src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/d1-104236851.png"></el-image>
        <div class="orientation-text-top">
          <span>智能统计分析</span>
          <span>实验全流程溯源</span>
        </div>
        <div class="orientation-text-bottom">
          <span>智能统计分析</span>
          <span>实验全流程溯源</span>
        </div>
      </div>

      <div class="orientation-cards">
        <div v-for="item in orientation" :key="item.title" class="orientation-card">
          <div class="orientation-card-title">{{ item.title }}</div>
          <div v-for="value in item.description" :key="value" class="orientation-card-desc">{{ value }}</div>
        </div>
      </div>
    </div>

    <div class="function-section">
      <div class="section-title function-title">核心功能</div>

      <div class="function-content">
        <div v-for="item in functions" :key="item.title" class="function-card">
          <el-image class="function-icon" :src="item.icon"></el-image>
          <div class="function-title-text">{{ item.title }}</div>
          <div class="function-desc">{{ item.description }}</div>
        </div>
      </div>
    </div>

    <div class="system-section">
      <div class="section-title">智能实验室信息管理系统</div>

      <div class="system-content">
        <div v-for="(item, index) in systems" :key="item.icon" class="system-item"
          :class="{ reverse: index % 2 === 1 }">
          <div class="system-text-card" :class="{ right: index % 2 === 1 }">
            <div class="system-title">{{ item.title }}</div>
            <div class="system-desc">{{ item.description }}</div>
          </div>
          <div>
            <el-image class="system-img" :src="item.icon"></el-image>
          </div>
        </div>
      </div>
    </div>

    <div class="banner-section">
      <div class="banner-title">敏捷协作，助力团队效率提升</div>
      <div class="banner-btn hover-btn" @click="$router.push('/')">
        <span>现在开始</span><i class="el-icon-arrow-right"></i>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Site2Home",
  data() {
    return {
      orientation: [
        {
          title: '科研更高效',
          description: ['自动报告生成、自动生成任务 自动数据计算', '自动图片处理 、AI智能文献搜索、AI智能统计分析']
        },
        {
          title: '数据可追溯',
          description: ['数据真实可追溯、出入库管理 、数据安全管理', '实验全流程追溯 、库存预警、电子签章自动图片处理 、AI智能文献搜索、AI智能统计分析']
        },
        {
          title: '管理更规范',
          description: ['供应链管理、实验管理 、交付管理、仪器管理', '采购管理 、人员管理、试剂耗材抗体管理']
        },
        {
          title: '流程更透明',
          description: ['数据真实可追溯、出入库管理 、数据安全管理', '实验全流程追溯 、库存预警、电子签章']
        },
      ],
      systems: [
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/w1-134352125.png',
          title: '项目管理',
          description: '实验记录、采购、库存无缝对接，计划分解执行,更有效的追踪工作线索，确保项目进度，降低延期风险。看板式任务管理，直观的查看每个项目的进展情况，项目下的所有工作、动态、文件、进展，对于项目下的所有成员都是透明可见的，大家都可以及时了解到项目当前的进度情况。'
        },
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/w2-134352127.png',
          title: '供应商&采购',
          description: '统一管理试剂、耗材、危化品等实验材料，通过个性灵活的审核机制及管理台账，实现了申购人、采购人、入库人、使用人，数量，项目，经销商结账等环节的全程闭环监管。让数据可追溯，让材料管理更顺畅和便捷有效'
        },
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/w3-134352131.png',
          title: '库存管理',
          description: '实时对实验室各类耗材、设备库存进行管控，实时呈现所有出入库记录，低库存及时预警、一键采购，支持非采购订单入库更贴合实验室实际情况，支持建立多库存放、分库盘点维护。'
        },
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/w4-134352087.png',
          title: '仪器预约',
          description: '通过事先预约仪器、实时查看仪器预约与使用情况，减少实验员使用实验仪器时间冲突事件概率，辅助提高实验员对实验时间的合理安排性，实现实验室管理员对各类仪器设备的高效利用与管理。'
        },
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/w5-134352124.png',
          title: '样本管理',
          description: '为科研工作者量身打造的一款基于云模式的生物样本库信息化管理产品，为用户提供有效的图形化样本管理流程；并在安全、可靠、稳定的前提下，追踪并管理样本实体所关联的数据信息从而有效的提升样本的使用价值及科研价值。'
        },
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/w6-134352110.png',
          title: '移动办公',
          description: '关注微信公众号或从手机进入官网即刻拥有移动云端轻版本，无需下载任何APP、没有任何安装捆绑。从电脑端YLab进入扫描二维码更可享受电脑、手机互联服务，微信实时接收电脑端所有通知消息、快速查看各项申请进度、便捷处理各类审批单据、实时添加实验记录。'
        },
      ],
      scheme: [
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/f1-102353574.png',
          title: '多终端 跨平台 随时可用',
          description: '在网页、安卓手机和苹果手机上都能轻松使用，多端间实时无缝切换'
        },
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/f2-102353573.png',
          title: 'SaaS技术',
          description: '软件即服务，免费升级，版本及时迭代，定期更新软件功能，满足更多业务需求，提高用户体验'
        },
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/f3-102353575.png',
          title: '云存储',
          description: '不受地域限制'
        },
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/f4-102353573.png',
          title: '适应性',
          description: 'YLabCloud提供随心而变的业务管理来适应多变的需求'
        }, {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/f5-102353565.png',
          title: '快速部署',
          description: '免安装，快速配置，超低转化成本'
        }, {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/f6-102353560.png',
          title: '安全性',
          description: '阿里云安全技术认证'
        },
      ],
      carousel: [
        {
          url: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/03/l1-181200650.png'
        }
      ],
      carouselItems: [
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/03/全流程一体化@2x-182136056.png',
          title: '全流程一体化',
          description: '贯通方案设计与实验执行全链路'
        },
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/03/合规可追溯@2x-182136024.png',
          title: '合规可追溯',
          description: '依托系统云端秒级记录实验全程'
        },
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/03/高效协同@2x-182136061.png',
          title: '高效协同',
          description: '通过“手脑分离”明确各环节职责'
        },
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/03/AI科研赋能@2x-182136051.png',
          title: 'AI科研赋能',
          description: '全面提升科研效率与产出质量'
        },
      ],
      functions: [
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/c1-113617392.png',
          title: '流程一体化',
          description: '打破数据孤岛，整合项目管理、实验管理、样本管理、采购库存、仪器管理、数据报表等六大核心模块，实现模块间高效联动，贯通方案设计与实验执行全链路，构建高效闭环的协同管理体系'
        },
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/c2-113617395.png',
          title: '数据可追溯',
          description: '依托系统云端对实验全程的秒级记录，实现实验数据、操作记录全过程可查、可溯、可验，全程留痕不可篡改。搭配电子签名、实验流程线上审批，全方位满足科研监管要求'
        },
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/c3-113617398.png',
          title: '高效协同',
          description: '通过“手脑分离”明确各环节职责，减少沟通成本，规避重复工作，加速科研进程，提升团队协作效率'
        },
        {
          icon: 'https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/c4-113617395.png',
          title: 'AI科研赋能',
          description: '依托DeepSeek与PubMed双源接入能力，大幅降低科研人员的重复工作量，实现从文献调研、数据分析到成果输出的全流程 AI 赋能，全面提升科研效率与产出质量。'
        },
      ]
    };
  },
  methods: {},
};
</script>

<style scoped lang="less">
/* 轮播区域 */
.carousel-wrapper {
  height: 670px;
  position: relative;
}

.carousel-img {
  width: 100%;
  height: 100%;
}

.carousel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.overlay-content {
  width: 1288px;
}

.main-title {
  color: #1D2129;
  font-weight: 700;
  font-size: 52px;
  line-height: 52px;
}

.sub-title {
  margin-top: 26px;
  color: #29282E;
  font-size: 32px;
  line-height: 50px;
}

.line-group {
  display: flex;
  gap: 20px;
  margin-top: 80px;
}

.white-line {
  width: 45px;
  height: 4px;
  background: #FFFFFF;
}

.carousel-bottom-cards {
  width: 1288px;
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: -43px;
}

.feature-card {
  width: 310px;
  height: 86px;
  background: linear-gradient(180deg, #F2F4F7 0%, #FEFEFE 100%);
  box-shadow: 2px 2px 14px 0px rgba(102, 100, 170, 0.1);
  border-radius: 7px;
  border: 1px solid;
  border-image: linear-gradient(180deg, rgba(242, 244, 247, 1), rgba(249, 250, 251, 1), rgba(255, 255, 255, 1)) 1;
  padding-top: 19px;
  padding-left: 20px;
  display: flex;
  gap: 18px;
}

.feature-icon {
  width: 46px;
  height: 46px;
}

.feature-title {
  font-weight: 500;
  font-size: 16px;
  color: #1D2129;
  line-height: 20px;
}

.feature-desc {
  font-size: 14px;
  color: #636E80;
  line-height: 20px;
  margin-top: 8px;
}

/* 产品区域 */
.product-section {
  padding-top: 126px;
  height: 660px;
}

.section-title {
  text-align: center;
  font-weight: 500;
  font-size: 40px;
  color: #1D2129;
  line-height: 40px;
}

.product-content {
  width: 1288px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding-top: 60px;
}

.product-left {
  position: relative;
}

.product-sub-title {
  font-weight: 500;
  font-size: 32px;
  color: #282C33;
  line-height: 36px;
}

.product-list {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0;
  list-style: none;
}

.product-list li {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 18px;
  color: #282C33;
  line-height: 28px;
}

.dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #282c33;
}

.decor-img1 {
  width: 86px;
  height: 68px;
  position: absolute;
  top: -23px;
  left: -20px;
  z-index: -1;
}

.product-right {
  position: relative;
}

.product-main-img {
  width: 601px;
  height: 348px;
}

.decor-img2 {
  width: 752.5px;
  height: 525.5px;
  position: absolute;
  right: -109px;
  bottom: -104px;
  z-index: -1;
}

/* 解决方案 */
.solution-section {
  height: 648px;
  background: #F6F7FB;
  padding-top: 62px;
}

.solution-content {
  margin-top: 72px;
  width: 1288px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding-top: 72px;
}

.solution-card {
  width: 416px;
  height: 179px;
  background: #FBFCFE;
  box-shadow: 0px 4px 20px 0px rgba(127, 127, 127, 0.1);
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 20px;
}

.solution-title {
  font-size: 20px;
  color: #282C33;
  line-height: 20px;
}

.solution-desc {
  font-size: 14px;
  color: #848B99;
  line-height: 20px;
  margin-top: 19px;
}

.solution-icon {
  width: 120px;
  height: 120px;
}

/* 核心定位 */
.orientation-section {
  height: 1040px;
  background: url('https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/di2-103821470.png') center/cover no-repeat;
  padding-top: 86px;
}

.orientation-sub-title {
  font-size: 18px;
  color: #1D2129;
  line-height: 20px;
  margin-top: 30px;
  text-align: center;
}

.orientation-img-wrapper {
  margin-top: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.orientation-main-img {
  width: 678px;
  height: 469px;
}

.orientation-text-top {
  position: absolute;
  top: 85px;
  left: 50%;
  transform: translate(-49%, 0%);
  display: flex;
  gap: 580px;
  white-space: nowrap;
  font-size: 20px;
  color: #3D3D3D;
  line-height: 20px;
}

.orientation-text-bottom {
  position: absolute;
  top: 271px;
  left: 50%;
  transform: translate(-49%, 0%);
  display: flex;
  gap: 741px;
  white-space: nowrap;
  font-size: 20px;
  color: #3D3D3D;
  line-height: 20px;
}

.orientation-cards {
  width: 1288px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.orientation-card {
  width: 634px;
  height: 132px;
  background: #FBFCFE;
  border-radius: 8px;
  padding: 28px 20px;


}

.orientation-card-title {
  font-size: 20px;
  color: #282C33;
  line-height: 20px;
  margin-bottom: 16px;
}

.orientation-card-desc {
  font-size: 14px;
  color: #848B99;
  line-height: 20px;
}

/* 核心功能 */
.function-section {
  height: 684px;
  background: linear-gradient(180deg, #FFFFFF 0%, #F3F6FF 100%);
}

.function-title {
  padding-top: 86px;
}

.function-content {
  width: 1288px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 60px;

}

.function-card {
  width: 307px;
  height: 418px;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px 0px rgba(127, 127, 127, 0.1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  padding-top: 65px;

  .function-icon {
    width: 90px;
    height: 90px;
  }

  .function-title-text {
    font-size: 20px;
    color: #282C33;
    line-height: 20px;
  }

  .function-desc {
    font-size: 14px;
    color: #848B99;
    line-height: 26px;
    padding: 0 31px;
  }

  &:hover {
    background: #2E98FE;
    cursor: pointer;
    transition: all 0.2s ease;

    .function-title-text {
      color: #fff;
    }

    .function-desc {
      color: #fff;
    }
  }
}


/* 系统模块 */
.system-section {
  padding-top: 86px;
}

.system-content {
  width: 1344px;
  margin: 0 auto;
  margin-top: 60px;
}

.system-item {
  display: flex;
  gap: 71px;
  margin-bottom: 85px;
  align-items: flex-end;
  transform: translate(-28px);

  &.reverse {
    transform: translate(28px);
    flex-direction: row-reverse;
  }
}

.system-text-card {
  width: 643px;
  height: 355px;
  padding: 76px 124px 0 56px;
  background: url('https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/w8-145210966.png') center/cover no-repeat;
  text-align: left;

  &.right {
    background: url('https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/w7-134954601.png') center/cover no-repeat;
    text-align: end;
  }
}

.system-title {
  font-weight: 500;
  font-size: 32px;
  color: #282C33;
  line-height: 36px;
}

.system-desc {
  font-weight: 400;
  font-size: 14px;
  color: #282C33;
  line-height: 28px;
  margin-top: 40px;
}

.system-img {
  width: 630px;
  height: 369px;
}

/* 底部banner */
.banner-section {
  height: 350px;
  background: url('https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2026/06/04/w9-150515572.png') center/cover no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 46px;
}

.banner-title {
  font-weight: 500;
  font-size: 40px;
  color: #1D2129;
  line-height: 44px;
}

.banner-btn {
  width: 168px;
  height: 48px;
  background: #2e98fe;
  border-radius: 6px;
  font-weight: 500;
  font-size: 20px;
  color: #ffffff;
  line-height: 48px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    margin-right: 12px;
  }
}

/* 按钮动画 */
.hover-btn {
  i {
    transition: all 0.1s ease-in-out;
  }

  &:hover {
    i {
      transform: translateX(10px);
    }
  }
}
</style>